import { s, h } from '../lib/sx'
import { A } from '../lib/router'
import { PageHero } from '../components/PageHero'
import { Plate } from '../components/Plate'
import { copy } from '../content/copy'
import { projects } from '../content/projects'

/** `All` plus each distinct sector, in the order the projects declare them. */
export const sectorFilterNames = ['All', ...new Set(projects.map((p) => p.sector))]

export function Projects({ filter, setFilter }: { filter: string; setFilter: (f: string) => void }) {
  const visible = projects.filter((p) => filter === 'All' || p.sector === filter)

  return (
    <div>
      <PageHero eyebrow="Projects" title={copy.projects.headline} />
      <section style={s('max-width:1320px;margin:0 auto;padding:clamp(44px,7vw,44px) clamp(18px,4vw,32px) clamp(48px,7vw,100px);')}>
        <div style={s('display:flex;gap:8px;flex-wrap:wrap;align-items:center;padding-bottom:28px;border-bottom:1px solid #DCE0E5;margin-bottom:44px;')}>
          {sectorFilterNames.map((name) => {
            const active = name === filter
            return (
              <button
                key={name}
                onClick={() => setFilter(name)}
                aria-pressed={active}
                style={s(
                  `background:${active ? '#1B2430' : 'transparent'};color:${active ? '#F2F4F6' : '#566070'};border:1px solid #DCE0E5;padding:10px 18px;font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:0.12em;text-transform:uppercase;cursor:pointer;`,
                )}
                className={h('border-color:#A8500F;')}
              >
                {name}
              </button>
            )
          })}
          <span style={s("margin-left:auto;font-family:'IBM Plex Mono',monospace;font-size:11px;color:#7E8894;letter-spacing:0.1em;")}>{visible.length} shown</span>
        </div>

        <div style={s('display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,260px),1fr));gap:32px;')}>
          {visible.map((p) => (
            <A key={p.slug} href={`/projects/${p.slug}`} style={s('display:block;')}>
              <Plate box="aspect-ratio:4/3;display:flex;align-items:flex-end;padding:16px;" src={p.image} caption={p.photo} captionStyle="padding:6px 10px;border-left:2px solid #1F5C99;" />
              <div style={s("font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:0.16em;text-transform:uppercase;color:#A8500F;margin:18px 0 8px;")}>
                {p.sector} · {p.province}
              </div>
              <h3 style={s('font-family:Archivo,sans-serif;font-weight:600;font-size:20px;line-height:1.2;letter-spacing:-0.01em;margin:0;')}>{p.title}</h3>
              <div style={s("font-family:'IBM Plex Mono',monospace;font-size:11.5px;color:#7E8894;margin-top:10px;")}>
                {p.value} · {p.year} · {p.status}
              </div>
            </A>
          ))}
        </div>
      </section>
    </div>
  )
}
